import { render, staticRenderFns } from "./subject_duration.vue?vue&type=template&id=48c00dd0&scoped=true&"
import script from "./subject_duration.vue?vue&type=script&lang=js&"
export * from "./subject_duration.vue?vue&type=script&lang=js&"
import style0 from "./subject_duration.vue?vue&type=style&index=0&id=48c00dd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c00dd0",
  null
  
)

export default component.exports